import React from 'react';

import { Box, Container, Flex, Link, Text } from '@chakra-ui/react';

import { dateHelpers } from '@nocowanie/core/helpers';

import { defaultFooterSmallConfig } from './footer-small.config.model';
import { FooterSmallProps } from './footer-small.props';
import { defaultFooterSmallTranslation } from './footer-small.translation.model';

const removeWhitespace = (string: string): string => {
    return string.replace(/\s/g, '');
};

const FooterSmall = ({
    translationData = defaultFooterSmallTranslation,
    config = defaultFooterSmallConfig,
    ...rest
}: FooterSmallProps): JSX.Element => {
    const { hotline, customerServiceEmail, openingHoursFrom, openingHoursTo } = config;

    return (
        <Box bg={'secondary.50'} py={6} as={'footer'} hideBelow={'sm'} {...rest}>
            <Container maxWidth={'oldContainerWidth'}>
                <Flex alignItems={'center'} gap={7} flexWrap={'wrap'}>
                    <Box mr={7}>
                        <Text>
                            {translationData.customerServiceHotline}:{' '}
                            <Link
                                variant={'plain'}
                                fontWeight={'bold'}
                                href={`tel:${removeWhitespace(hotline)}`}
                                colorPalette={'gray'}
                            >
                                {hotline}
                            </Link>
                        </Text>
                        <Text fontSize={'sm'} color={'gray.700'}>
                            {translationData.openingHours
                                .replace(/{{value}}/, openingHoursFrom)
                                .replace(/{{value2}}/, openingHoursTo)}
                        </Text>
                    </Box>

                    <Box>
                        <Link
                            variant={'plain'}
                            colorPalette={'gray'}
                            href={`mailto:${customerServiceEmail}`}
                        >
                            {customerServiceEmail}
                        </Link>
                    </Box>

                    <Text
                        as={'small'}
                        ml={'auto'}
                        color={'gray.700'}
                        fontSize={'xs'}
                        w={{
                            base: '100%',
                            md: 'auto',
                        }}
                    >
                        Copyright 2005-{dateHelpers.format(new Date(), 'yyyy')} by NOCOWANIE.PL Sp.
                        z o.o.
                    </Text>
                </Flex>
            </Container>
        </Box>
    );
};

export { FooterSmall };
